import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IEditHistoryItemPayload, IEditHistoryItemResponse } from '../types';
import { AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_QUERY, AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS } from '../../../constants';
import {
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_API_URL,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_MUTATION,
  AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_QUERY,
} from '../constants';

export default function useEditHistoryNoneNegativeCarryoverMutation(): IContextMutationResult<
  IEditHistoryItemResponse,
  Error,
  IEditHistoryItemPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IEditHistoryItemResponse, Error, IEditHistoryItemPayload>({
    mutationKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_MUTATION],
    mutationFn: ({ itemId, ...payload }) => fetchPut<IEditHistoryItemResponse>(
      AFFILIATE_NONE_NEGATIVE_CARRYOVER_EDIT_HISTORY_API_URL,
      payload,
      {
        permission: AFFILIATES_NONE_NEGATIVE_CARRYOVER_PERMISSIONS.EDIT,
        urlParams: {
          itemId,
        },
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_HISTORY_QUERY, variables.itemId] });
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_NONE_NEGATIVE_CARRYOVER_SHOW_QUERY] });

      displayPresetToast('edited');
    },
  });
}
